import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import i18nIsoCountries from 'i18n-iso-countries';
@Injectable({
  providedIn: 'root'
})
export class IsoCountriesService {

  constructor(
    @Inject(LOCALE_ID) private defaultLocale: string
  ) {

  }

  // i18n-iso-countries wrappers
  // https://github.com/michaelwittig/node-i18n-iso-countries/
  getName(alpha2orAlpha3orNumeric: string | number, lang?: string): string {
    if (!lang) {
      lang = this.defaultLocale;
    }
    return i18nIsoCountries.getName(alpha2orAlpha3orNumeric, lang);
  }

  getNames(lang?: string): i18nIsoCountries.LocalizedCountryNames<i18nIsoCountries.GetNameOptions> {
    if (!lang) {
      lang = this.defaultLocale;
    }
    return i18nIsoCountries.getNames(lang);
  }

  langs(): string[] {
    return i18nIsoCountries.langs();
  }

  isValid(alpha2orAlpha3orNumeric: string | number): boolean {
    return i18nIsoCountries.isValid(alpha2orAlpha3orNumeric);
  }

}
